module.exports = __webpack_public_path__ + "img/75794091_p1.dca7117b.png";